import type { ComponentPropsWithoutRef, JSX } from 'react';

import { cx } from './internal/cx.js';

export type SeparatorSize = '1' | '2' | '3' | '4';

export interface SeparatorProps extends ComponentPropsWithoutRef<'hr'> {
  /** Vertical separator instead of horizontal. */
  orientation?: 'horizontal' | 'vertical';
  /** Spacing scale — larger values add more margin around the separator. */
  size?: SeparatorSize;
}

/** Visually or semantically separates content. */
export function Separator({
  className,
  orientation = 'horizontal',
  size = '1',
  ...props
}: SeparatorProps): JSX.Element {
  return (
    <hr
      role="separator"
      aria-orientation={orientation}
      className={cx(
        'nrx-separator',
        `nrx-separator--size-${size}`,
        orientation === 'vertical' && 'nrx-separator--vertical',
        className,
      )}
      {...props}
    />
  );
}
